var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiTrust5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V75H37.7195L41 37.5L37.7195 0H0Z",
    fill: "#8BC0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 0H76V75H38V0Z",
    fill: "#3897FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.218 13.891L38 30.108L44.892 37L61.109 20.782L68 27.673V7H47.327L54.218 13.891Z",
    fill: "#BFDCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.782 61.109L37 44.892L30.108 38L13.891 54.218L7 47.327V68H27.673L20.782 61.109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTrust5);
export default __webpack_public_path__ + "static/media/ai-trust-5.ed5134da1fd85ff691c5789a0bb43e5b.svg";
export { ForwardRef as ReactComponent };